<img [class]="imgClasses()" [src]="src()" [alt]="alt()" />
